import React from 'react';
import ReactDOM from 'react-dom';
import './tailwind.css';  // Using Tailwind CSS
import PersonalInfoPage from './PersonalInfoPage';

ReactDOM.render(
  <React.StrictMode>
    <PersonalInfoPage />
  </React.StrictMode>,
  document.getElementById('root')
);
